import { render } from "./ApplicationsView.vue?vue&type=template&id=0b04343f&scoped=true"
import script from "./ApplicationsView.vue?vue&type=script&lang=js"
export * from "./ApplicationsView.vue?vue&type=script&lang=js"

import "./ApplicationsView.vue?vue&type=style&index=0&id=0b04343f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b04343f"]])

export default __exports__